export default __webpack_public_path__ + "static/media/skimlit.ff3ba472.jpg";